import React from "react";
import {
  DataGrid,
  Column,
  FormItem,
  Paging,
  Pager,
  Editing,
} from "devextreme-react/data-grid";
import uiInfo from "../../ui-info";
import PaginaToolbar from "../../components/PaginaToolbar";
import { criarCalculoManualDiatDs } from "../../DataSources";
import notify from "devextreme/ui/notify";

const localStorageKey = "cadastroDividaAtivaGridState";

export default class CalculoManualDiatBox extends React.Component {
  constructor() {
    super();
    this.calculoManualDiatDs = criarCalculoManualDiatDs();
  }

  cancelar() {
    return notify("Não implementado...", "error");
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <PaginaToolbar
          titulo="Cálculo Manual de Dívida Ativa"
          novoCb={this.novoRegistro.bind(this)}
        >
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.calculoManualDiatDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            focusedRowEnabled={false}
            allowColumnReordering={true}
          >
            <Editing
                allowDeleting={true}
                allowUpdating={true}
                useIcons={true}
              />
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                "edit",
                "delete"
                // {
                  
                //   hint: "Cancelar",
                //   icon: "remove",
                //   onClick: (e) => {
                //     this.cancelar(e);
                //   },
                // }
              ]}
            />
            <Column
              dataField={"id"}
              visible={true}
              caption={"#"}
              sortIndex={0}
              sortOrder={"desc"}
              width={90}
              alignment={"center"}
              allowEditing={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"data"}
              visible={true}
              dataType="date"
              editorType="dxDateBox"
              showInColumnChooser={false}
              width={120}
            >
              <FormItem visible={true}></FormItem>
            </Column>

            <Column
              dataField={"dividaId"}
              visible={true}
              caption={"DIAT ID"}
              alignment={"center"}
              width={110}
            />

            <Column
              dataField={"divida.sequencial"}
              visible={true}
              caption={"DIAT Seq."}
              alignment={"center"}
              width={110}
            />

            <Column
              dataField={"principal"}
              caption={"Principal (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />

            <Column
              dataField={"multa"}
              caption={"Multa (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />

            <Column
              dataField={"juros"}
              caption={"Juros (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />

            <Column
              dataField={"correcao"}
              caption={"Correção (R$)"}
              editorType={"dxNumberBox"}
              format={"#,##0.00"}
              editorOptions={{ format: "#,##0.00" }}
              cssClass="txtNumerico"
            />
            
            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

            <Pager
              showInfo={true}
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }

  novoRegistro() {
    let gridState = this._gridInstance.instance.state();
    localStorage.setItem(localStorageKey, JSON.stringify(gridState));
    this.props.history.push("/calculo-divida-ativa/novo");
  }
}
